import { observer } from 'mobx-react'
import React from 'react'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { MarkerPin4Icon } from '@flowwai-frontend/design-system/icons'

import { useMapsUtilityContext } from '../../hooks/useMapsUtilityContext'
import { MapCoordinates } from '../../types'
import MapMarkerPopup from '../MapMarkerPopup/MapMarkerPopup'

interface Props {
   isReadOnly: boolean
   searchedLocation: MapCoordinates
   onAddCoordinates: (coordinates: MapCoordinates) => void
}

const SearchedLocationMarkerPopup = (props: Props): React.ReactElement => {
   const { isReadOnly, searchedLocation, onAddCoordinates } = props

   const { mapsT } = useMapsUtilityContext()

   const renderHeader = (): React.ReactElement => (
      <p className='text-xs-semibold text-gray-700'>
         {mapsT('markerPopup.searchedLocationHelpText')}
      </p>
   )

   const renderFooter = (): React.ReactElement =>
      isReadOnly ? (
         <></>
      ) : (
         <Button
            size={'Small'}
            hierarchy={Hierarchy.Primary}
            subVariant={SubVariant.Primary}
            leftIcon={({ stroke }) => <MarkerPin4Icon stroke={stroke} />}
            onClick={() => onAddCoordinates(searchedLocation)}
         >
            {mapsT('markerPopup.addLocation')}
         </Button>
      )

   return (
      <MapMarkerPopup
         index={-1}
         coordinates={searchedLocation}
         isReadOnly
         onUpdateCoordinate={() => null}
         onDeleteCoordinates={() => null}
         containerClassName='flex flex-col gap-2'
         renderHeader={isReadOnly ? undefined : renderHeader}
         renderFooter={renderFooter}
      />
   )
}

export default observer(SearchedLocationMarkerPopup)
